import React from 'react';

function MobileDelete() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='19' height='19' viewBox='0 0 19 19'>
      <g
        fill='none'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        data-name='Group 13131'
        transform='translate(-1 -1)'
      >
        <path
          d='M6.981 2h7.038L19 6.981v7.038L14.019 19H6.981L2 14.019V6.981z'
          data-name='Path 363'
        />
        <path d='M5 0L0 5' data-name='Line 39' transform='translate(8 8)' />
        <path d='M0 0L5 5' data-name='Line 40' transform='translate(8 8)' />
      </g>
    </svg>
  );
}

export default MobileDelete;
